export default class KeyValue {
  public key: string;

  public value: string;

  constructor(key: string, value: string) {
    this.key = key;
    this.value = value;
  }
}
